'use strict';

var Backbone = require('backbone');
var moment = require('moment-timezone');
var polyglot = require('../utilities/polyglot').default;

var TYPES = {
  NEXT_AVAILABLE: 1,
  CERTAIN_DAYS: 2,
};

var DAYS = {
  0: moment().isoWeekday(7).format('dddd'),
  1: moment().isoWeekday(1).format('dddd'),
  2: moment().isoWeekday(2).format('dddd'),
  3: moment().isoWeekday(3).format('dddd'),
  4: moment().isoWeekday(4).format('dddd'),
  5: moment().isoWeekday(5).format('dddd'),
  6: moment().isoWeekday(6).format('dddd'),
};

var regex12Hour = RegExp('^(0?[1-9]|1[0-2]):[0-5][0-9]\\s?[aApP][mM]$');
var regex24Hour = RegExp('^([01]?[0-9]|2[0-3]):?[0-5][0-9]$');

export default Backbone.Model.extend({
  formatTime: function () {
    if (this.get('type') === TYPES.CERTAIN_DAYS) {
      var start = this.get('start_time');
      var end = this.get('end_time');

      start = moment(start, regex12Hour.test(start) ? 'hh:mm a' : 'HH:mm');
      end = moment(end, regex12Hour.test(end) ? 'hh:mm a' : 'HH:mm');

      this.set('start_time', start.format('HH:mm:ss'));
      this.set('end_time', end.format('HH:mm:ss'));
    }
  },

  invalidTimeFormat: function (time) {
    return time.length < 4 || (!regex12Hour.test(time) && !regex24Hour.test(time));
  },

  validate: function (attrs, options) {
    var errors = '';

    if (attrs.type === TYPES.CERTAIN_DAYS) {
      if (this.invalidTimeFormat(attrs.start_time)) {
        return this.invalidTimeFormat(attrs.end_time)
          ? polyglot.t('advanced_wait_list.time.invalid.error')
          : polyglot.t('advanced_wait_list.start_time.invalid.error');
      } else if (this.invalidTimeFormat(attrs.end_time)) {
        return polyglot.t('advanced_wait_list.end_time.invalid.error');
      }

      var start = moment(attrs.start_time, regex12Hour.test(attrs.start_time) ? 'hh:mm a' : 'HH:mm');
      var end = moment(attrs.end_time, regex12Hour.test(attrs.end_time) ? 'hh:mm a' : 'HH:mm');
      var diff = end.diff(start, 'minutes');
      if (diff <= 0) {
        errors = polyglot.t('advanced_wait_list.end_time.after.error');
      }
    }

    return errors;
  },
}, {
  DAYS,
  TYPES,
});
